// removed by extract-text-webpack-plugin
module.exports = {"panel":"panel__3kGoS"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Network/coms/UnauthorizedPacketView/styles.scss
// module id = 2308
// module chunks = 1